function normalizeError(error) {
  return String(error || '').toLowerCase();
}

export function getUnavailableState(entityLabel, error) {
  const normalized = normalizeError(error);

  if (normalized.includes('permission') || normalized.includes('insufficient')) {
    return {
      title: `This ${entityLabel} is not available to you`,
      message: `It may be private, expired, sold, or only accessible to the current owner or participants in the transaction.`,
    };
  }

  if (normalized.includes('not found')) {
    return {
      title: `This ${entityLabel} is no longer available`,
      message: `The link may be old, the page may have expired, or the record may no longer be public.`,
    };
  }

  return {
    title: `This ${entityLabel} is unavailable right now`,
    message: `Try again later or return to the marketplace. If the problem continues, the link may no longer be active.`,
  };
}
